import { CausaliData } from "./CausaliData";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { changeDatesToUTC } from "../utils/dateUtils";
import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { queryClient } from "../App";
import { API_URL } from "../consts";
import { useSnackbar } from "notistack";
import {
  Button,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

type Inputs = {
  descrizione: string;
  moltiplicatore: number;
};

export function EditCausale(props: { causale?: CausaliData; handleClose: () => void }) {
  const { causale, handleClose } = props;
  const { enqueueSnackbar } = useSnackbar();

  const schema = yup
    .object({
      descrizione: yup.string().max(50).required(),
      moltiplicatore: yup.number().required(),
    })
    .required();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: Inputs) => {
    changeDatesToUTC(data);
    if (causale) mutateUpdate(data);
    else mutate(data);
  };

  const { mutate } = useMutation(
    (data: Inputs) => {
      return axios.post(API_URL + "causali", data);
    },
    {
      onSuccess: (data) => {
        const { id } = data.data;
        if (id) {
          queryClient.invalidateQueries();
          enqueueSnackbar("Causale creata", { variant: "success" });
          handleClose();
        }
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const { mutate: mutateUpdate } = useMutation(
    (data: Inputs) => {
      return axios.patch(API_URL + "causali/" + causale?.id, data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Causale aggiornato", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DialogContent>
        <Grid container rowSpacing={1} columnSpacing={1}>
          <Grid item xs={12}>
            <Controller
              name="descrizione"
              control={control}
              defaultValue={causale?.descrizione ?? ""}
              render={({ field }) => (
                <TextField
                  {...field}
                  required
                  fullWidth
                  variant="standard"
                  label="Descrizione"
                  error={Boolean(errors.descrizione)}
                  helperText={errors.descrizione?.message ?? ""}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="moltiplicatore"
              control={control}
              defaultValue={causale?.moltiplicatore ?? 1}
              render={({ field }) => (
                <RadioGroup {...field} defaultValue={1} row>
                  <FormControlLabel value={1} control={<Radio />} label="+" />
                  <FormControlLabel value={-1} control={<Radio />} label="-" />
                </RadioGroup>
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleClose()}>Chiudi</Button>

        {!causale && <Button type="submit">Crea Causale</Button>}

        {causale && <Button type="submit">Modifica Causale</Button>}
      </DialogActions>
    </form>
  );
}
